"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var Sentry = _interopRequireWildcard(require("@sentry/react"));
var _envManager = require("../utils/envManager");
var _environments = require("../utils/environments");
var _WopiContext = require("../context/WopiContext");
var _constants = require("../constants");
var _branding = require("../utils/branding");
var _IcertisConfigureScreen = _interopRequireDefault(require("../components/auth/IcertisConfigureScreen"));
var _LoginSelectionScreen = _interopRequireDefault(require("../components/auth/LoginSelectionScreen"));
var _SigningInPage = _interopRequireDefault(require("./SigningInPage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var copilotVeraHost;
var copilotDioptraHost;
if (process.env.AUTH_URL.includes("propelauthtest")) {
  copilotVeraHost = "copilot.test.vera.icertis.com";
  copilotDioptraHost = "copilot.propelauthtest.com";
} else {
  copilotVeraHost = "copilot.vera.icertis.com";
  copilotDioptraHost = "copilot.dioptra.ai";
}
var DIOPTRA_HANDOFF_HASH = "#dioptra";
var RESET_HASH = "#reset";
var VERA_ENVIRONMENT_IDS = {
  eu: {
    prod: "cust-prod-eu",
    uat: "cust-staging-eu"
  },
  row: {
    prod: "cust-prod-us",
    uat: "cust-staging-us"
  }
};
var VERA_ENVIRONMENT_SELECTIONS = {
  "cust-prod-eu": {
    region: "eu",
    envTier: "prod"
  },
  "cust-staging-eu": {
    region: "eu",
    envTier: "uat"
  },
  "cust-prod-us": {
    region: "row",
    envTier: "prod"
  },
  "cust-staging-us": {
    region: "row",
    envTier: "uat"
  }
};
function veraEnvironmentFor(region, envTier) {
  var envId = VERA_ENVIRONMENT_IDS[region][envTier];
  return _environments.VERA_ENVIRONMENTS.find(function (env) {
    return env.id === envId;
  });
}
var resolveInitialView = function resolveInitialView(isVeraHost, isWopi, entryHash) {
  if (entryHash === DIOPTRA_HANDOFF_HASH) {
    if (isVeraHost) {
      window.location.href = "https://".concat(copilotDioptraHost, "/taskpane.html").concat(DIOPTRA_HANDOFF_HASH);
      return null;
    }
    return "signingIn";
  }
  var saved = entryHash === RESET_HASH ? null : localStorage.getItem(_constants.DIOPTRA_LOGIN_METHOD);

  // On the Dioptra host with a saved Icertis preference, redirect to Vera.
  // This is strictly one-directional (Dioptra → Vera) so it can never loop.
  if (saved === "icertis" && !isVeraHost && !isWopi) {
    window.location.href = "https://".concat(copilotVeraHost, "/taskpane.html");
    return null;
  }
  if (isVeraHost) {
    return "configure";
  }
  return "selection";
};
var LoggedOutPage = function LoggedOutPage() {
  var _wopi$environment$id, _wopi$environment;
  var isVeraHost = (0, _branding.isVeraHostname)();
  var wopi = (0, _WopiContext.useWopiSession)();
  var wopiEnvironmentId = (_wopi$environment$id = (_wopi$environment = wopi.environment) === null || _wopi$environment === void 0 ? void 0 : _wopi$environment.id) !== null && _wopi$environment$id !== void 0 ? _wopi$environment$id : null;
  var appliedEnvironmentId = (0, _environments.findMatchingEnvironment)((0, _envManager.getEnvOverrides)());
  var wopiResolved = wopi.isWopi && wopiEnvironmentId !== null && appliedEnvironmentId === wopiEnvironmentId;
  var _useState = (0, _react.useState)(function () {
      return window.location.hash;
    }),
    _useState2 = _slicedToArray(_useState, 1),
    entryHash = _useState2[0];
  var _useState3 = (0, _react.useState)(function () {
      var _resolveInitialView;
      if (wopiResolved) {
        return "signingIn";
      }
      return (_resolveInitialView = resolveInitialView(isVeraHost, wopi.isWopi, entryHash)) !== null && _resolveInitialView !== void 0 ? _resolveInitialView : "selection";
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    view = _useState4[0],
    setView = _useState4[1];
  (0, _react.useEffect)(function () {
    if (entryHash === DIOPTRA_HANDOFF_HASH) {
      (0, _envManager.clearEnvOverrides)();
      localStorage.setItem(_constants.DIOPTRA_LOGIN_METHOD, "dioptra");
    } else if (entryHash === RESET_HASH) {
      localStorage.removeItem(_constants.DIOPTRA_LOGIN_METHOD);
    }
    if (entryHash) {
      window.location.hash = "";
    }
  }, [entryHash]);
  var matchedSelection = appliedEnvironmentId === null ? null : VERA_ENVIRONMENT_SELECTIONS[appliedEnvironmentId];
  var _useState5 = (0, _react.useState)(function () {
      var _matchedSelection$reg;
      return (_matchedSelection$reg = matchedSelection === null || matchedSelection === void 0 ? void 0 : matchedSelection.region) !== null && _matchedSelection$reg !== void 0 ? _matchedSelection$reg : null;
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    region = _useState6[0],
    setRegion = _useState6[1];
  var _useState7 = (0, _react.useState)(function () {
      var _matchedSelection$env;
      return (_matchedSelection$env = matchedSelection === null || matchedSelection === void 0 ? void 0 : matchedSelection.envTier) !== null && _matchedSelection$env !== void 0 ? _matchedSelection$env : "prod";
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    envTier = _useState8[0],
    setEnvTier = _useState8[1];
  var handleRegionChange = function handleRegionChange(r) {
    setRegion(r);
    (0, _environments.applyEnvironment)(veraEnvironmentFor(r, envTier));
  };
  var handleEnvTierChange = function handleEnvTierChange(t) {
    setEnvTier(t);
    if (region !== null) {
      (0, _environments.applyEnvironment)(veraEnvironmentFor(region, t));
    }
  };
  var handleDioptraLogin = function handleDioptraLogin() {
    if (isVeraHost) {
      window.location.href = "https://".concat(copilotDioptraHost, "/taskpane.html").concat(DIOPTRA_HANDOFF_HASH);
      return;
    }
    (0, _envManager.clearEnvOverrides)();
    localStorage.setItem(_constants.DIOPTRA_LOGIN_METHOD, "dioptra");
    setView("signingIn");
  };
  var handleIcertisLogin = function handleIcertisLogin() {
    if (region === null) {
      return;
    }
    (0, _environments.applyEnvironment)(veraEnvironmentFor(region, envTier));
    localStorage.setItem(_constants.DIOPTRA_LOGIN_METHOD, "icertis");
    setView("signingIn");
  };
  function handleIcertisSelect() {
    return _handleIcertisSelect.apply(this, arguments);
  }
  function _handleIcertisSelect() {
    _handleIcertisSelect = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var resolved, selection;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            localStorage.setItem(_constants.DIOPTRA_LOGIN_METHOD, "icertis");
            if (!wopi.isWopi) {
              _context.n = 2;
              break;
            }
            _context.n = 1;
            return wopi.session.resolve();
          case 1:
            resolved = wopi.session.getState();
            if (resolved.environment) {
              (0, _environments.applyEnvironment)(resolved.environment);
              selection = VERA_ENVIRONMENT_SELECTIONS[resolved.environment.id];
              setRegion(selection.region);
              setEnvTier(selection.envTier);
            }
            setView("configure");
            return _context.a(2);
          case 2:
            if (isVeraHost) {
              _context.n = 3;
              break;
            }
            window.location.href = "https://".concat(copilotVeraHost, "/taskpane.html");
            return _context.a(2);
          case 3:
            setView("configure");
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleIcertisSelect.apply(this, arguments);
  }
  (0, _react.useEffect)(function () {
    if (!wopiResolved) {
      return;
    }
    Sentry.addBreadcrumb({
      category: "wopi",
      level: "info",
      message: "resolved session (env=".concat(wopiEnvironmentId, ") \u2192 auto-bypassing configure screen, starting login")
    });
    localStorage.setItem(_constants.DIOPTRA_LOGIN_METHOD, "icertis");
    setView("signingIn");
  }, [wopiResolved, wopiEnvironmentId]);
  var isDioptraCloud = !isVeraHost && !wopi.isWopi;
  if (view === "signingIn") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SigningInPage.default, {
      backLabel: isDioptraCloud ? "Switch Cloud" : undefined,
      onBack: function onBack() {
        return setView(isVeraHost ? "configure" : "selection");
      }
    });
  }
  if (view === "configure") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisConfigureScreen.default, {
      region: region,
      setRegion: handleRegionChange,
      envTier: envTier,
      setEnvTier: handleEnvTierChange,
      onLogin: handleIcertisLogin,
      onBack: function onBack() {
        return setView("selection");
      }
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginSelectionScreen.default, {
    onIcertisSelect: function onIcertisSelect() {
      void handleIcertisSelect();
    },
    onDioptraLogin: handleDioptraLogin,
    "data-sentry-element": "LoginSelectionScreen",
    "data-sentry-component": "LoggedOutPage",
    "data-sentry-source-file": "LoggedOutPage.tsx"
  });
};
var _default = exports.default = LoggedOutPage;